import React from 'react'
import FilterDateRangeV2 from '../../../home/components/filters/FilterDateRangeV2'
import { Input, Select } from 'antd'

const { Search } = Input

const GroupBatchFilter = (props) => {

    const {
        handleChangeInput,
        handleChangeDate,
        created,
        userCreate,
        onChangeUserCreated,
        listUser,
    } = props

    const _handleChangeName = (value) => {
        if (typeof handleChangeInput === 'function') {
            handleChangeInput('name', value)
        }
    }

    const _handleChange = e => {
        const { value } = e.target
        _handleChangeName(value)
    }

    const _handleChangeDate = (field, value) => {
        const cloneFilter = Object.assign({}, created)

        cloneFilter[field] = value

        if (value.from === '' || value.to === '') {
            delete cloneFilter[field]
        }

        handleChangeDate(cloneFilter)
    }

    return (
        <div className='BatchesPageContainer'>
            <div className='row align-items-start'>
                <div className='FilterNameBatch col-12 col-xl-4 mb-3'>
                    <label className="d-block w-100 font-weight-bold mb-1">Tên lô</label>
                    <div className='SearchField'>
                        <Search
                            placeholder='Tìm kiếm theo tên Lô...'
                            onChange={_handleChange}
                            allowClear={true}
                        />
                    </div>
                </div>
                <div className='col-12 col-xl-3 mb-3'>
                    <label className="d-block w-100 font-weight-bold mb-1">Ngày tạo</label>
                    <FilterDateRangeV2 field='created_at' onDatesChange={_handleChangeDate} showTime={true} />
                </div>

                {
                    !!listUser.length &&
                    <div className='col-12 col-xl-3 mb-3'>
                        <label className="d-block w-100 font-weight-bold mb-1">Người tạo</label>
                        <Select
                            mode="multiple"
                            style={{ width: '100%' }}
                            placeholder="Vui lòng chọn người tạo bạn muốn tìm kiếm"
                            onChange={onChangeUserCreated}
                            value={userCreate}
                            allowClear
                        >
                            {
                                listUser.map((option, index) => {
                                    return <Select.Option key={index} value={option}>{option}</Select.Option>
                                })
                            }
                        </Select>
                    </div>
                }
            </div>
        </div>
    )
}

export default GroupBatchFilter